module.exports = __webpack_public_path__ + "static/media/correct-01.34934a7b.png";